import { Component } from 'react';
import {connect} from 'react-redux';
import {getMarketingConsents, updateMarketingConsent} from '../../../actions/marketing_consent';
import AdminEditor from '../../common/editor/admin-editor';

class MarketingConsent extends Component {
  UNSAFE_componentWillMount() {
    this.props.dispatch(getMarketingConsents());
  }

  render() {
    let consents = 'No Marketing Consents Found';

    if (this.props.marketingConsents.marketingConsents && this.props.marketingConsents.marketingConsents.length > 0) {
      consents = this.props.marketingConsents.marketingConsents.map(consent => (
        <AdminEditor
          key={consent.condition}
          onClickAction={updateMarketingConsent}
          content={consent.content}
          identifier={consent.condition}
          editorTitle={consent.condition.toUpperCase().split('_').join(' ')}
        />

      ));
    }

    return (
      <div className="container-fluid marketing-consents">
        <h1>Update marketing consent text</h1>
        {consents}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state,
  marketingConsents: state.marketingConsents
});

export default connect(mapStateToProps)(MarketingConsent);
